<template>
  <tr :class="{ upload: upload }" :key="item.id">
    <td>
      <div v-if="edit" class="height width">
        <BaseInput
          :placeholder="
          localStorage.translations.pages.sales_project['schemes_documents-tables']['nazvanie']
        "
          height="48px"
          v-model="data.name"
          :rules="['required', 'max100']"
        />
      </div>
      <div class="name" v-else>
        <ProjectSchemesAndDocumentsPdfModal :url="url">
          <template slot="text">
            <div class="name_top">
              <p class="f14">
                {{ item.name }}
              </p>
              <span class="ml-1">.{{ fileExtension ? fileExtension : item.extension }}</span>
            </div>
          </template>
        </ProjectSchemesAndDocumentsPdfModal>
        <span class="name_size f14">{{ fileSize ? fileSize : item.size }}</span>
      </div>
      <BaseTableUploadProgress
        class="mt-4"
        v-if="tableMin && upload"
        :status="item.status"
        :uploadProgress="uploadDocumentsProgress"
      />
    </td>
    <td v-if="!tableMin && upload" :colspan="3">
      <BaseTableUploadProgress :status="item.status" :uploadProgress="uploadDocumentsProgress" />
    </td>
    <template v-if="!upload">
      <td>
        <div class="height width">
          <BaseInput
            type="autocomplete"
            :disabled="!documentTypeList.length"
            height="48px"
            v-model="data.document_type_id"
            :items="documentTypeList"
            :tooltip="
            localStorage.translations.pages.sales_project['schemes_documents-tooltips'][
              'dobavte-tip-dokumenta'
            ]
          "
            :tooltip-disabled="!edit || documentTypeList.length ? true : false"
            :view="!edit"
            :view-value="
            item.type
              ? item.type.name
              : localStorage.translations.pages.sales_project['schemes_documents-tables'][
                  'ne-vybrano'
                ]
          "
          >
            <WorkDocsDocumentTypeModal v-if="edit == true" :create="true" :minimalize="true" />
          </BaseInput>
        </div>
      </td>
      <td v-if="!upload" class="f14" :class="{ noSelect: !item.type }">
        {{ $formatDate(item.created_at) }}
      </td>
      <td v-else></td>
      <td v-if="!upload">
        <div class="buttons">
          <ProjectSchemesAndDocumentsPdfModal icon-show :url="url" />
          <DeleteModal
            v-if="editShowPage && !edit"
            :item="item"
            :page="page"
            :limit="limit"
            type="workDocsProjectDocuments"
            :text="
              localStorage.translations.pages.sales_project['schemes_documents-dialog-delete'][
                'text_document'
              ] +
              ' ' +
              item.name
            "
          />
        </div>
      </td>
      <td v-else></td>
    </template>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import DeleteModal from 'components/DeleteModal'
import WorkDocsDocumentTypeModal from 'components/setting/workDocsDocumentType/WorkDocsDocumentTypeModal'
import ProjectSchemesAndDocumentsPdfModal from 'components/project/schemesAndDocuments/ProjectSchemesAndDocumentsPdfModal'
import BaseButton from "components/base/BaseButton.vue";

export default {
  name: 'ProjectDocumentsTableItem',
  components: {
    WorkDocsDocumentTypeModal,
    DeleteModal,
    ProjectSchemesAndDocumentsPdfModal,
  },
  props: [
    'item',
    'itemKey',
    'page',
    'limit',
    'edit',
    'documentTypeList',
    'upload',
    'editShowPage',
    'tableMin',
  ],
  data: () => ({
    fileSize: null,
    fileExtension: null,
    url: null,
    data: {
      name: null,
      document_type_id: null,
    },
  }),
  watch: {
    item() {
      this.onActualData()
    },
    edit() {
      this.onActualData()
    },
    data: {
      handler: function (oldVal, newVal) {
        if (this.edit) {
          this.itemData(true)
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['inputRules']),
    ...mapGetters('workDocsProjectDocuments', ['uploadDocumentsProgress']),
  },
  mounted() {
    this.onActualData()
  },
  methods: {
    onActualData() {
      this.data.name = this.item.name
      this.data.document_type_id = this.item.type ? this.item.type.id : null
      if (this.item.files && !this.upload) {
        let filesData = JSON.parse(this.item.files)
        this.fileExtension = filesData[0].extension
        this.fileSize = filesData[0].size
        this.url = filesData[0].url
      }
      this.itemData()
    },
    itemData(edit) {
      if (this.edit) {
        let data = {
          id: this.item.id,
          project_id: this.$route.params.id,
          files: this.item.files,
        }
        data = { ...this.data, ...data }
        this.$emit('itemData', { data, type: edit ? 'edit' : false, key: this.itemKey })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.height {
  height: 100%;
}
.width {
  min-width: 280px;
}
tr:deep() {
  &.upload {
    background-color: #f8fcff;
    &:hover {
      background-color: #f8fcff !important;
    }
  }
  td {
    height: auto !important;
    .name {
      .name_top {
        display: grid;
        grid-template-columns: auto max-content;
        justify-content: start;
        align-items: center;
        align-content: center;
        p {
          margin: 0;
          line-height: 1 !important;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          color: var(--v-secondary-darken4);
        }
      }
      span {
        display: block;
        color: #b4b4b4;
        font-weight: normal;
        overflow-wrap: normal;
        @media #{map-get($display-breakpoints, 'sm-and-down')} {
          text-align: right;
        }
      }
    }
    &.noSelect {
      span {
        color: #b4b4b4 !important;
      }
    }
    .customBtn {
      margin-top: 5px;
    }
  }
}
</style>
